import { getLangProperty, IEDate, uGetDateFormat } from '@appbase/util';
import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'

import DatePicker from '@appbase/components/DatePicker/DatePicker.vue'
import TimePicker from '@appbase/components/TimePicker/TimePicker.vue';

@Component({
    components: {
        DatePicker,
        TimePicker
    }
})
export default class DatetimeField extends Vue {
    @Prop({ type: Object }) context!: board.ContentField;
    @PropSync('returnValue', { type: String }) datetimeModel!: string | null;
    @Prop({ type: Object }) initOptions!: any;

    mDate: string = '';
    mTime: string = '09:00:00';

    get displayName() {
        return getLangProperty(this.context, 'displayName');
    }

    @Watch('mDate')
    @Watch('mTime')
    onDatetimeChanged() {
        this.datetimeModel = `${this.mDate} ${this.mTime}`;
    }

    initTime() {
        this.mDate = uGetDateFormat('yyyy-MM-dd', new Date());

        if (this.context.fieldType === 'DATETIME-END') {
            this.mTime = '10:00:00';
        } else {
            this.mTime = '09:00:00';
        }

        if (this.initOptions && this.initOptions.DatetimeField) {
            var options = this.initOptions.DatetimeField;

            this.mDate = options.date;
            this.mTime = options.time;
        }       
    }

    created() {
        if (this.datetimeModel != null && this.datetimeModel.length > 0) {
            var datetime = IEDate(this.datetimeModel);

            this.mDate = uGetDateFormat('yyyy-MM-dd', datetime);
            this.mTime = uGetDateFormat('H:i:s', datetime);
        } else {
            this.initTime();
        }

        this.datetimeModel = `${this.mDate} ${this.mTime}`;
    }
}